var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-mb-4 tw-text-2xl tw-font-medium sm:tw-text-3xl md:tw-mb-8 lg:tw-text-4xl"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }